// src/components/About.js
import React from 'react';
import './About.css'; // Optional for custom styles

function About() {
  return (
    <section className="about">
      <h2>About Me</h2>
      <p>I'm [Your Name], a [Your Profession] with a passion for [Your Passion].</p>
      <h3>Skills</h3>
      <ul>
        <li>Skill 1</li>
        <li>Skill 2</li>
        <li>Skill 3</li>
      </ul>
    </section>
  );
}

export default About;
